import React from "react";
import {cx} from "../../lib/ClassSet";
import "./TaskIcon.css";

const TaskIcon = (props) => {

  let classNames = cx({
    "TaskIcon": true,
    "u-completed": props.completed,
    "u-gift": props.gift
  })

  if (props.gift) {
    return (
      <div className={classNames} />
    )
  }

  let label = <span>{props.nr}</span>
  if (props.completed) {
    label = <svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="#1EA763" strokeWidth="5" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="bevel">
          <path d="M17,26 L24.0622577,34.0622577 L32,16"></path>
        </g>
      </svg>
  }

  return (
    <div className={classNames}>
      {label}
    </div>
  )

}

TaskIcon.defaultProps = {
  completed: false,
  gift: false,
  nr: 0
}

export default TaskIcon;